import { api } from '@/core/lib/api-client';
import { UserDto, ResetPasswordDto, ResponseType } from '@link-in-bio/domain';

export const resetPassword = (resetPasswordDto: ResetPasswordDto): Promise<ResponseType<UserDto>> => {
  return api.post(`/auth/reset-password`, resetPasswordDto);
};
